import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { store } from "Store";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { validateToken } from "./ResetPasswordAxiosFuncs";
import { PATHS } from "Utils/PagePaths";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import ResetPasswordVerifyEmailMFA from "./Component/ResetPasswordVerifyEmailMFA";
import ResetPasswordSetupEmailMFA from "./Component/ResetPasswordSetupEmailMFA";

const ResetPasswordEmailMFA = () => {

  const { token } = useParams();
  const loginState = store.getState().loginInfo;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isForward = location.state?.isForward;

  const [forwardPage, setForwardPage] = useState(0);
  const [mfaFactors, setMfaFactors] = useState({
    mfaEmail: null
  })

  // init load to validate the token in the URL from the email
  const initLoad = async (token) => {
    // the Reset Password MFA can only be operated when the user is not login!
    if (loginState.token) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.GENERAL_ERROR.title,
          msg: "Please sign out to reset password.",
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      });

      return;
    }

    const res = await validateToken(token)
      .catch(function (error) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        return error.response;
      });

    //console.log("initLoad() reset password email mfa", res);
    if (res && res.data?.status !== 1) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: res.data.globalErrorMessageList,
          showContactHelp: true
        },
        redirect: {
          redirect: true,
          redirectFirst: true,
          path: PATHS.public['Get Help'],
          data: {}
        }
      });
      return;
    }

    if (res && res.data?.status === 1) {

      // from select mfa page, display the page content
      // forwardPage:1: Reset Password; 2: Setup MFA;   3: Verify MFA 
      if (isForward) {

        setForwardPage(res.data.data?.forwardPage);
        setMfaFactors({
          mfaEmail: res.data.data?.email
        });

        // setIsLoading(false);
        // setMfaFactors({
        //   mfaEmail: res.data.data?.email
        // });

        return;
      }
      // go back to the select mfa page and sort out the flow 
      navigate("/password/token/" + token);
    }

    // if (res && res.data?.status === 1) {
    //   // forwardPage:1: Reset Password; 2: Setup MFA;   3: Verify MFA 
    //   // if (res.data.data?.forwardPage === 1) {
    //   //   navigate("/password/token/" + token + "/3", { state: { isForward: true } });
    //   // } else {
    //   //   setForwardPage(res.data.data?.forwardPage);
    //   // }
    // }
  }

  // init
  useEffect(() => {
    initLoad(token);
  }, []);

  return (
    <>
      {forwardPage === 3 ?
        <ResetPasswordVerifyEmailMFA
          token={token}
          mfaFactors={mfaFactors}
        />
        : null
      }
      {forwardPage === 2 ?
        <ResetPasswordSetupEmailMFA
          token={token}
          mfaFactors={mfaFactors}
        />
        : null
      }
    </>
  )
}

export default ResetPasswordEmailMFA;